import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  printMerch,
  uiuxIcon,
  brandingIcon,
} from "../../../../assets/icons/serviceIcon/index";
import GraphicDesigningWork from "./GraphicDesigningWork";

const items = [
  {
    name: "Social Media Creatives",
    text: "We make scroll-stopping designs that grab attention and reflect your brand’s personality. Every post, story, or reel is crafted to stand out and stay true to who you are.",
  },
  {
    name: "Marketing Collaterals",
    text: "From brochures and flyers to pitch decks and ads, we design marketing materials that are not just beautiful but also clear, focused, and effective at getting your message across.",
  },
  {
    name: "Packaging Design",
    text: "We help your products stand out on the shelf (and online). Our packaging designs blend creativity with clarity so customers notice, remember, and trust your brand.",
  },
];

const otherService = [
  {
    icon: brandingIcon,
    name: "Branding & Identity",
    des: "Helping brands feel real, relatable, and ready to stand out.",
    path: "/branding-and-label",
  },
  {
    icon: uiuxIcon,
    name: "UI/UX Design",
    des: "Smooth, smart, and seamless experiences your users will love.",
    path: "/ui-ux-designing",
  },
  {
    icon: printMerch,
    name: "Print & Merchandise Design",
    des: "Bring your brand to life with designs people want to own.",
    path: "/print-and-merchandise",
  },
];

const GraphicDesigning = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Designing"
        description="We believe design speaks before words do. It’s that first silent hello from your brand. Whether it’s a social media post, brochure, or website banner, we make sure every design feels like you. Clean, creative, and made with heart, just the way your brand deserves to be seen."
        heading="Graphic"
      />
      <NewCommonServiceForm title="Graphic Designing" items={items} />
      <GraphicDesigningWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default GraphicDesigning;
